<template>
    <h1 class="title mb-2" style="text-align: left; font-size: calc(1rem + 2vw); color: white;  font-weight: bold " >Рецепт "Запечённые перепёлки (для гриля и духовки)"</h1>
    <div class="" >
      <img
          src="/assets/recipe1.svg"
          class="recipe-image"
          alt="..."
      >
    </div>
    <div class="recipe-1-container text-white text-start mt-3" style="">
      <div class="layout__content">
          <div class="ms-1 w-big-screen " style="font-size: calc(1rem + 0.4vw);">
            <p>1. Просушить тушки бумажными полотенцами;</p>
            <p>2. Натереть растительным маслом, посолить и поперчить;</p>
            <p>3. Надеть перепёлок на ростер;</p>
            <p>4. Просушить 40-60 минут на ветру, под вентилятором или, слегка, феном; Если красивая, аккуратная корочка не обязательна, то можно этот шаг пропустить;</p>
            <p>5. Запекать на непрямом жаре в гриле при 160-180&deg;C 40-50 минут. По желанию можно подкоптить, бросив вначале на угли/брикеты горсть замоченной щепы. Можно запекать и в духовке при той же температуре в режиме &laquo;конвекция&raquo;.</p>
          </div>
          <p style="font-size: calc(1rem + 0.4vw);"><strong>Приятного аппетита!</strong></p>
      </div>
    </div>

</template>

<style scoped lang="scss">
@media (max-width: 600px) {
  .recipe-image {
    width: 100%!important;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}
@media (max-width: 1100px) and (min-width: 601px) {
  .recipe-image {
    width: 100%!important;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}
@media (min-width: 1101px) and (max-width: 1799px) {
  .w-big-screen{
    width: 50%!important;
  }
  .recipe-image {
    width: 60%!important;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}
@media (min-width: 1800px) {
  .w-big-screen{
    width: 50%!important;
  }
  .recipe-image {
    width: 50%;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}

.recipes-container{
  position: relative;
  max-width: 100%;
  margin-bottom: 5%;
  min-width: 15%;
  width: auto;
}

</style>
